import { Injectable } from "@angular/core";
import * as bootstrap  from 'bootstrap';


@Injectable({
    providedIn: 'root'
  })
  export class MessageService {

    private _message?:string

    showMessage(mess:string,id:string){
        this.message =mess;
        const elt =document.getElementById(id);
        const toast = new bootstrap.Toast(elt!!);
    
        toast.show();
    }
   public get message(){
    return this._message?this._message:'';
   }
   public set message(message:string){
    this._message=message;
   }
  }